export default [
  {
    name: "Humle",
    id: "1482d707-e5d1-44ae-a8f7-3da8522a1bb2",
  },
  {
    name: "Fläder",
    id: "cc229189-849c-419a-8cc7-e2375d9413ec",
  },
  {
    name: "Rudbeckia",
    id: "ec6114d0-f0a2-4578-b207-4d20d7777811",
  },
  {
    name: "Johannesört",
    id: "d0667434-f29c-4583-a60f-c42dd3d2c702",
  },
  {
    name: "Bolmört",
    id: "5b020a12-2931-4349-a58c-5d8d4945b948",
  },
  {
    name: "Malört",
    id: "d7be54da-f6e2-4d4a-a87a-249d39b33db4",
  },
  {
    name: "Vallört",
    id: "2df5a95f-7c2b-4b42-8748-8c836cbc56fc",
  },
  {
    name: "Kamomill",
    id: "6c448dd9-ef2e-48f8-bc0e-13b6a742dad8",
  },
]; /* .map(({ name, id }) => ({
  name,
  id,
  locationId: '949636dc-997a-4aa2-8582-7c81a12dad4d'
})) */
